'use client';

/**
 * Style Guidance Section
 *
 * @component_role Explorer section type `style_guidance`
 * @business_rule Renders the persistent Style Guidance pane (DesignIntent
 *   create form + saved guides list). Passes the full labels dict through
 *   to StyleGuidance so the inner form and list render with server-driven
 *   translated strings.
 *
 * @layer presentation
 * @arch_component_type section
 * @arch_domain discovery
 */

import type { ExplorerSectionConfig, LabelsDict } from '@/lib/api/types';
import { StyleGuidance } from '../style-guidance';

export function StyleGuidanceSection({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  config,
  labels,
}: {
  config: ExplorerSectionConfig;
  labels: LabelsDict;
}) {
  return <StyleGuidance labels={labels} />;
}
